export default "__VITE_ASSET__CY0H1Lfc__"